import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    message: String,
    tooltipClass: String,
  };

  connect() {
    this.tooltip = document.createElement("div");
    this.tooltip.classList.add("tooltip");
    if (this.tooltipClassValue) {
      this.tooltip.classList.add(this.tooltipClassValue);
    }
    document.body.appendChild(this.tooltip);
  }

  show(event) {
    if (!this.messageValue) {
      return;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.tooltip.textContent = this.messageValue;
    this.positionTooltip(event);
    this.tooltip.style.opacity = 0;
    this.tooltip.style.display = "block";
    this.timeout = setTimeout(() => {
      this.tooltip.style.opacity = 1;
    }, 1);
  }

  hide() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.tooltip.style.opacity = 0;

    this.timeout = setTimeout(() => {
      this.tooltip.style.display = "none";
    }, 500);
  }

  positionTooltip(event) {
    const { pageX, pageY, clientX, clientY } = event;
    const tooltipRect = this.tooltip.getBoundingClientRect();
    const offset = 10; // Space between cursor and tooltip
    // pageX/pageY: document coords for position:absolute on body
    this.tooltip.style.left = `${pageX + offset}px`;
    this.tooltip.style.top = `${pageY + offset}px`;

    // Viewport overflow checks use client coords (scroll-independent)
    if (clientX + tooltipRect.width + offset > window.innerWidth) {
      this.tooltip.style.left = `${pageX - tooltipRect.width - offset}px`;
    }
    if (clientY + tooltipRect.height + offset > window.innerHeight) {
      this.tooltip.style.top = `${pageY - tooltipRect.height - offset}px`;
    }
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.remove();
    }
  }
}
